export const env = { ...process.env, ...window['allie_app_env'] }
